/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *******************************************************************************/

import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@mui/styles';
import { makeStyles } from '@mui/styles';
import { connect } from 'react-redux';
import { compose } from 'redux';
import ParticlesUI from '../../../ui-elements/particlesUI';


const styles = makeStyles(theme => ({
    root: {
    },
    imageDotedDescp: {
        transition: 'transform .2s',
        marginLeft: 'auto',
        marginRight: 'auto',
        display: 'block',
        width: '100%',
        maxWidth: '600px',

        "&:hover": {
            transform: 'scale(1.2)',

        }
    },
    sectionTitleBorder: {
        width: '50px',
        height: '2px',
        marginRight: 'auto',
        marginLeft: 'auto',
        backgroundColor: '#fb743e',

    }
}));


const mainInfoHeader = ({ t }) => {
    const classes = styles();

    return (
        <>
            <Grid container spacing={4} style={{ marginRight: '50px', backgroundColor: 'rgb(0 0 0 )', position: 'relative' }}>

                <Grid item xs={12} sm={12} md={12} >


                    <div style={{ position: 'relative' }}>

                        <Grid container spacing={4}>
                            <Grid item xs={12} sm={12} md={12} style={{ paddingTop: '100px' }} >
                                <Typography variant="h1" color="primary" align="center" style={{
                                    fontWeight: "700",
                                    fontSize: "45px"
                                }} p>WELCOME TO THERAYTEK</Typography>
                                <Typography variant="h1" align="center" color="text.primary" >IT Services and Consulting</Typography>

                            </Grid>

                        </Grid>

                    </div>
                </Grid>
                <Grid item xs={12} sm={12} md={12} >
                    <ParticlesUI />
                    <div >
                        <Grid container spacing>
                            <Grid item xs={12} sm={12} md={6} style={{ paddingTop: '5%',paddingLeft:'20px' }} >
                                <Typography variant="h1" align="center" style={{
                                    color: "#fff",
                                    fontWeight: "700",

                                    fontSize: "45px"
                                }} paragraph>

                                </Typography>
                                <div className={classes.sectionTitleBorder}></div>

                                <Typography variant="h2" align="center" style={{ color: "#fff", padding: '10px' }} paragraph>
                                    THERAYTEK is an IT services and consulting company.
                                </Typography>

                                <Typography variant="h1" align="center" style={{ color: "#fff", textTransform: "uppercase" }} paragraph>
                                    We explore possibilities and strive for excellence
                                </Typography>
                                <Typography variant="h3" align="center" style={{ color: "#fff" }} paragraph>
                                    We help our customers  run and manage  their vision
                                    by creating a bespoke roadmap for each client and 
                                    delivering on time with results that exceed expectations.
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} >
                                <img src="/assets/images/bg/preview.png" className={classes.imageDotedDescp} alt="" />
                            </Grid>
                        </Grid>

                    </div>
                </Grid>
            </Grid>
        </>
    );
}

const mapStateToProps = () => {
    return {
        //   loginned: state.loginned
    }
}

const mapDispatchToProps = () => {
    return {

    }
}

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    withStyles(styles)
)(mainInfoHeader);